<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>
 
    </nav> -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <!-- <nav class="sidebar sidebar-offcanvas" id="sidebar">
            <ul class="nav">

                <li class="nav-item">

                    <a class="nav-link" href="../../index.html">
                        <img src="../../assets/navIcon/Dashboard.png" />&nbsp;&nbsp;
                        <span class="menu-title">Dashboard</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="mdi.html">
                        <img src="../../assets/navIcon/Audit.png" />&nbsp;&nbsp;
                        <span class="menu-title">Audit</span>
                        <i class="mdi mdi-contacts menu-icon"></i>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="../forms/basic_elements.html">
                        <img src="../../assets/navIcon/License.png" />&nbsp;&nbsp;
                        <span class="menu-title">licence</span>
                        <i class="mdi mdi-format-list-bulleted menu-icon"></i>
                    </a>
                </li>


                <li class="nav-item">
                    <a class="nav-link" data-toggle="collapse" href="#ui-basic" aria-expanded="false"
                        aria-controls="ui-basic">
                        <img src="../../assets/navIcon/Master.png" />&nbsp;&nbsp;
                        <span class="menu-title">Master</span>
                        <i class="menu-arrow"></i>
                        <i class="mdi mdi-crosshairs-gps menu-icon"></i>
                    </a>
                    <div class="collapse" id="ui-basic">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item"> <a class="nav-link" href="../ui-features/buttons.html">Prod</a></li>
                            <li class="nav-item"> <a class="nav-link">Notices</a></li>
                            <li class="nav-item"> <a class="nav-link">Ports</a></li>
                            <li class="nav-item"> <a class="nav-link" routerLink="/countrymaster">Country</a></li>
                            <li class="nav-item"> <a class="nav-link">Currency</a></li>
                        </ul>
                    </div>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/Portmaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">Port</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/countrymaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">Terms & Conditions</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/currencymaster">
                        <img src="../../assets/navIcon/Copyrigths.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">CopyRights</span>

                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="/">
                        <img src="../../assets/navIcon/Logout.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">LogOut</span>

                    </a>
                </li>

            </ul>
        </nav> -->
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">PORT</h2>
                </div>

                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Code</label><span style="color: red;">*</span><br />
                            <input type="text" id="PortCode" maxlength="7" [(ngModel)]="PortCode" (blur)="Show($event)" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Name </label><span style="color: red;">*</span><br />
                            <input type="text" id="PortName" [(ngModel)]="PortName" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Type </label><span style="color: red;">*</span><br />
                            <!-- <input type="text" id="Type" [(ngModel)]="Type" class="txt-input" /> -->
                            <select name="Type" id="Type" [(ngModel)]="Type" class="txt-input">
                                <option value="0" selected disabled>Select</option> 
                                <option value="Air">Air</option>
                                <option value="Sea">Sea</option>
                                <option value="ICD">ICD</option>
                                <option value="ACC">ACC</option>
                                <option value="CFS">CFS</option>
                                <option value="LCS">LCS</option>
                            </select>
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-6">
                            <label>Address Line 01</label><br />
                            <input type="text" id="Address1" [(ngModel)]="Address1" class="txt-input" />
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-6">
                            <label>Address Line 02</label><br />
                            <input type="text" id="Address2" [(ngModel)]="Address2" class="txt-input" />
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3">
                            <label>City</label><br/>
                            <input type="text" id="City" [(ngModel)]="City" class="txt-input" />
                        </div>
                        <div class="col-lg-3">
                            <label>State</label><br/>
                            <input type="text" id="State" [(ngModel)]="State" class="txt-input" />
                        </div>                       
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3">
                            <label>Country</label><span style="color: red;">*</span><br/>
                            <input type="text" id="Country" [(ngModel)]="Country" class="txt-input" list="countryid" (blur)="Show($event)"/>
                            <datalist id="countryid" >
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cnt of countrys" value={{cnt.countryname}}>{{cnt.countryname}}</option>
                            </datalist>
                        </div>
                        <div class="col-lg-3">
                            <label>Pin</label><br/>
                            <input type="text" id="zip" [(ngModel)]="zip" class="txt-input" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-5" style="padding-top:1em;">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" id="Description" [(ngModel)]="Description" class="txt-input"></textarea>
                        </div>
                        <div class="col-lg-3" style="padding-top: 4rem;" [hidden]="isShownActive">
                            <input type="checkbox" id="Status" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 4rem;">                            
                            <button class="bttn-save " (click)="SubmitPort()" [hidden]="isShownSaveBtn">SAVE</button> &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="UpdatePort()" [hidden]="isShownUpdateBtn">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear" (click)="ClearPort()">Clear</button>
                        </div>   
                    </div>

                    <div class="row">
                        <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                            
                            <span style="color: red;">{{ErrorMsg}}</span>
                            <span style="color: green;">{{SuccessMsg}}</span>
                        </div>
                    </div>
                   
                </div>
            </div>



            <div class="content-wrapper">

                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 grid-margin" >
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-3"></div>
                                                    <div class="col-lg-9" style="padding-right:0px;">
                                                        <div class="form-group" style="padding-left:55%;">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                <!-- <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div> -->
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color:black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="portcode">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Code</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditPort(element)"
                                                                style="cursor: pointer;"> {{element.portcode}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="portname">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                 Name</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditPort(element)"
                                                                style="cursor: pointer;"> {{element.portname}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="portType">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Type</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditPort(element)"
                                                                style="cursor: pointer;"> {{element.portType}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="address1">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Address</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditPort(element)"
                                                                style="cursor: pointer;"> {{element.address1}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="city">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                City</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditPort(element)"
                                                                style="cursor: pointer;"> {{element.city}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="country">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Country</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditPort(element)"
                                                                style="cursor: pointer;"> {{element.country}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditPort(element)"
                                                                style="cursor: pointer;"> {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>



                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>
    </div>
</div>